import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function Campus() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Our Campus</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Our Campus</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>About St. Mary’s Nursery School, Bokaro (SMNS)</h1>
                            <p>
                                <b><i>Nestled on a 0.5-acre green campus graciously granted by Bokaro Steel Limited, SMNS offers a safe, vibrant, and stimulating learning environment. The campus features:</i></b>
                            </p>

                            <ul className="checklist">
                                <li>A spacious two-storied old block and a modern three-storied new block.</li>
                                <li> Smart and colorful classrooms designed to engage young learners.</li>
                                <li> A well-maintained playground with an ultra-modern play station.</li>
                                <li> Complete Smart panel enabled classrooms, a playroom, and a music room that encourage creativity and expression.</li>
                                <li> A beautifully landscaped garden fostering a sense of nature and calm.</li>
                                <li> A full-time diesel generator ensuring uninterrupted power supply.</li>
                                <li> An RO-enabled water filtration plant providing safe and hygienic drinking water.</li>
                            </ul>

                            <h2>Our Academic Structure</h2>

                            <p>SMNS offers three foundational classes :- Pre-Nursery, Nursery, and Prep, each with multiple sections, maintaining a 1:15 teacher-student ratio to ensure personalized attention. Our well-qualified, trained, and compassionate educators follow the NEP-based play-way methodology that emphasizes joyful learning, experiential activities, and social-emotional growth.</p>

                            <h2>Our Legacy and Beyond</h2>
                            <p>As a proud member of the M.G.M. Group of Educational Institutions, SMNS shares its legacy with 34 other prestigious schools across India under the Diocese of Calcutta of the Indian Orthodox Church.</p>

                            <p>Our sister institution, the M.G.M. Higher Secondary School, located at Sector 4/F, Bokaro Steel City, is a CBSE-affiliated school with a strength of nearly 3500 students from Classes I to XII. Every student completing Prep at SMNS is ensured smooth admission to MGM Higher Secondary School, continuing their educational journey in the same ethos of excellence and care.</p>

                            <p>Children graduating from SMNS are consistently recognized for their confidence, discipline, creativity, and adaptability qualities that help them excel in any reputed school they choose for higher learning</p>

                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default Campus